module.exports = __webpack_public_path__ + "img/Desk Stationeryd02.9e5968a9.jpg";